import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import {
  Badge,
  Button,
  Divider,
  IconButton,
  MenuItem,
  Modal,
  Tooltip,
  Typography,
} from "@mui/material";
import Logo from "../assets/Logo.png";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

import LogoutIcon from "@mui/icons-material/Logout";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckIcon from "@mui/icons-material/Check";

import "./header.scss";
import { updateUser } from "../actions/user";
import toast from "react-hot-toast";
import { signOut } from "../Api/index";
import { SIDEBAR_COLORS, SIDEBAR_WIDTH, TOP_BAR_HEIGHT } from "./SideBar";

// eslint-disable-next-line react/prop-types
export default function Header({ sidebarOpen = true }) {
  const mode_state = useSelector((state) => state.mode);
  const [mode, setMode] = React.useState(mode_state);
  React.useEffect(() => {
    setMode(mode_state);
  }, [mode_state]);

  const [anchorElUser1, setAnchorElUser1] = React.useState(null);
  const [ModalOpen, setModalOpen] = React.useState(false);
  const unApprovedAssets = useSelector((state) => state.newAsset);
  const user = JSON.parse(secureLocalStorage.getItem("profile"));

  const handleOpenUserMenu1 = (event) => {
    setAnchorElUser1(event.currentTarget);
  };
  const handleCloseUserMenu1 = () => {
    setAnchorElUser1(null);
  };
  const handleOpen = () => {
    setModalOpen(true);
  };
  const handleClose = () => {
    setModalOpen(false);
  };

  const dispatch = useDispatch();
  const logout = () => {
    let loggingOutId;

    loggingOutId = toast.loading("Please wait we are logging you out...");
    dispatch(updateUser(user?.results._id, { login: "no", system: "none" }));
    setTimeout(() => {
      // Ends the shared login, so the other apps are logged out too
      signOut().catch(() => {});
      dispatch({ type: "LOGOUT" });
      navigate("/assets-register/login");
      toast.remove(loggingOutId);
    }, 2000);
  };

  const navigate = useNavigate();
  let blinkingMessage = false;

  if (
    (user?.results.assets === "Approver" ||
      user?.results.assets === "Administrator") &&
    unApprovedAssets.length >= 1
  ) {
    blinkingMessage = true;
  } else {
    blinkingMessage = false;
  }
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        elevation={0}
        position="fixed"
        sx={{
          px: { xs: 1.2, md: 2 },
          py: 0,
          boxSizing: "border-box",
          height: TOP_BAR_HEIGHT,
          justifyContent: "center",
          backgroundColor: SIDEBAR_COLORS.bg,
          borderBottom: `1px solid ${SIDEBAR_COLORS.line}`,
          boxShadow: "none",
          zIndex: 1200,
        }}
      >
        <Box
          sx={{
            // clear the sidebar plus the menu button beside it
            ml: { xs: 0, md: `${sidebarOpen ? SIDEBAR_WIDTH : 0}px` },
            pl: "44px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* Left Brand */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.2,
              minWidth: 0,
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 40,
                borderRadius: "14px",
                display: "grid",
                placeItems: "center",
                backgroundColor: "rgba(255,255,255,0.12)",
                border: "1px solid rgba(255,255,255,0.16)",
                boxShadow: "0 8px 18px rgba(15,23,42,0.14)",
                overflow: "hidden",
                flexShrink: 0,
              }}
            >
              <img
                width={31}
                height="auto"
                src={Logo}
                alt="src logo"
                style={{ display: "block" }}
              />
            </Box>

            <Box sx={{ minWidth: 0 }}>
              <Typography
                variant="h6"
                sx={{
                  lineHeight: 1,
                  fontSize: { xs: 14, sm: 16, md: 18 },
                  fontWeight: 950,
                  letterSpacing: "-0.02em",
                  color: mode === "dark" ? "#0883FF" : "#17b859",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <Link
                  to="/assets-register/"
                  style={{
                    color: "inherit",
                    textDecoration: "none",
                  }}
                >
                  Nyankumasi-Ahenkuro Community Bank Plc
                </Link>
              </Typography>

              <Typography
                sx={{
                  mt: 0.35,
                  fontSize: 10.5,
                  fontWeight: 800,
                  color: "rgba(255,255,255,0.72)",
                  display: { xs: "none", sm: "block" },
                }}
              >
                Assets Register & Approval Workspace
              </Typography>
            </Box>
          </Box>

          {/* Right Actions */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 0.7, sm: 1 },
              flexShrink: 0,
            }}
          >
            <Tooltip title="Click to logout">
              <IconButton
                size="small"
                onClick={handleOpen}
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: "12px",
                  backgroundColor:
                    mode === "dark"
                      ? "rgba(8,131,255,0.18)"
                      : "rgba(23,184,89,0.18)",
                  color: "#fff",
                  border:
                    mode === "dark"
                      ? "1px solid rgba(8,131,255,0.24)"
                      : "1px solid rgba(23,184,89,0.24)",
                  "&:hover": {
                    backgroundColor:
                      mode === "dark"
                        ? "rgba(8,131,255,0.28)"
                        : "rgba(23,184,89,0.28)",
                  },
                }}
              >
                <LogoutIcon sx={{ fontSize: 18 }} />
              </IconButton>
            </Tooltip>

            <Badge
              color="secondary"
              badgeContent={unApprovedAssets.length}
              max={100}
              sx={{
                "& .MuiBadge-badge": {
                  fontSize: 9,
                  height: 17,
                  minWidth: 17,
                  fontWeight: 900,
                  border: `2px solid ${SIDEBAR_COLORS.bg}`,
                },
              }}
            >
              <Tooltip title="Toggle notifications panel">
                <IconButton
                  size="small"
                  onClick={handleOpenUserMenu1}
                  sx={{
                    width: 34,
                    height: 34,
                    borderRadius: "12px",
                    backgroundColor: "rgba(255,255,255,0.10)",
                    color: "#fff",
                    border: "1px solid rgba(255,255,255,0.16)",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.18)",
                    },
                  }}
                >
                  <NotificationsIcon sx={{ fontSize: 19 }} />
                </IconButton>
              </Tooltip>
            </Badge>

            <Typography
              sx={{
                ml: { xs: 0, sm: 0.3 },
                px: 1.2,
                py: 0.55,
                borderRadius: "999px",
                border: "1px solid rgba(255,255,255,0.16)",
                backgroundColor: "rgba(255,255,255,0.10)",
                fontSize: { xs: 11, sm: 12 },
                fontWeight: 950,
                color: "#fff",
                lineHeight: 1,
                whiteSpace: "nowrap",
                display: { xs: "none", sm: "block" },
              }}
            >
              <Box
                component="span"
                sx={{
                  color: mode === "dark" ? "#0883FF" : "#17b859",
                  fontWeight: 950,
                }}
              >
                NARB.
              </Box>
              <Box
                component="span"
                sx={{
                  color: "#fff",
                  fontStyle: "italic",
                  fontWeight: 800,
                }}
              >
                Assets
              </Box>
            </Typography>
          </Box>
        </Box>

        <Menu
          sx={{ mt: "42px" }}
          id="menu-appbar"
          anchorEl={anchorElUser1}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={Boolean(anchorElUser1)}
          onClose={handleCloseUserMenu1}
          PaperProps={{
            elevation: 0,
            sx: {
              mt: 1,
              minWidth: 260,
              borderRadius: "16px",
              border: "1px solid #e2e8f0",
              boxShadow: "0 16px 40px rgba(15,23,42,0.16)",
              overflow: "hidden",
            },
          }}
        >
          <MenuItem
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              py: 1.25,
              cursor: "default",
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
          >
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 950,
                color: "#1e293b",
              }}
            >
              Notifications
            </Typography>

            <Typography
              sx={{
                mt: 0.25,
                fontSize: 11.5,
                color: "#64748b",
              }}
            >
              Assets register updates and approvals
            </Typography>
          </MenuItem>

          <Divider />

          <MenuItem
            onClick={() => {
              if (blinkingMessage) {
                handleCloseUserMenu1();
                navigate("/assets-register/approvals");
              }
            }}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              py: 1.35,
              backgroundColor: blinkingMessage
                ? "rgba(23,184,89,0.08)"
                : "#fff",
              "&:hover": {
                backgroundColor: blinkingMessage
                  ? "rgba(23,184,89,0.12)"
                  : "#f8fafc",
              },
            }}
          >
            {!blinkingMessage && (
              <>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 800,
                    color: "#64748b",
                  }}
                >
                  No messages available
                </Typography>

                <Typography
                  sx={{
                    mt: 0.25,
                    fontSize: 11,
                    color: "#94a3b8",
                  }}
                >
                  You have no pending asset alerts.
                </Typography>
              </>
            )}

            {blinkingMessage && (
              <>
                <Typography
                  sx={{
                    fontSize: 12.5,
                    fontWeight: 950,
                    color: "#116149",
                  }}
                >
                  {unApprovedAssets.length} asset
                  {unApprovedAssets.length > 1 ? "s" : ""} need approval
                </Typography>

                <Typography
                  sx={{
                    mt: 0.25,
                    fontSize: 11,
                    fontWeight: 700,
                    color: "#64748b",
                  }}
                >
                  Click to open the approvals page.
                </Typography>
              </>
            )}
          </MenuItem>
        </Menu>
      </AppBar>

      <Modal
        open={ModalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="animate__animated animate__pulse"
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "88%", sm: 400 },
            maxWidth: 420,
            borderRadius: "22px",
            bgcolor: "#fff",
            border: "1px solid #e2e8f0",
            boxShadow: "0 24px 70px rgba(15,23,42,0.24)",
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              px: 2.4,
              py: 2,
              backgroundColor: SIDEBAR_COLORS.bg,
              color: "#fff",
            }}
          >
            <Typography
              id="modal-modal-title"
              sx={{
                fontSize: 16,
                fontWeight: 950,
                letterSpacing: "-0.01em",
              }}
            >
              Logout Confirmation
            </Typography>

            <Typography
              sx={{
                mt: 0.5,
                fontSize: 12,
                color: "rgba(255,255,255,0.75)",
              }}
            >
              Confirm before exiting the assets register.
            </Typography>
          </Box>

          <Box sx={{ px: 2.4, py: 2.2 }}>
            <Box
              sx={{
                borderRadius: "16px",
                border: "1px solid #e2e8f0",
                backgroundColor: "#f8fafc",
                px: 1.6,
                py: 1.3,
                mb: 1.8,
              }}
            >
              <Typography
                sx={{
                  fontSize: 10.5,
                  fontWeight: 900,
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  color: "#94a3b8",
                }}
              >
                Logged in user
              </Typography>

              <Typography
                sx={{
                  mt: 0.4,
                  fontSize: 13.5,
                  fontWeight: 900,
                  color: "#1e293b",
                }}
              >
                {user?.results?.firstName + " " + user?.results?.lastName}
              </Typography>
            </Box>

            <Typography
              id="modal-modal-description"
              sx={{
                fontSize: 13,
                fontWeight: 700,
                color: "#475569",
                mb: 2.2,
              }}
            >
              Are you sure you want to exit?
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 1.2,
              }}
            >
              <Button
                onClick={logout}
                size="small"
                variant="contained"
                sx={{
                  flex: 1,
                  height: 36,
                  borderRadius: "12px",
                  backgroundColor: mode === "dark" ? "#0883FF" : "#116149",
                  textTransform: "capitalize",
                  fontSize: 12,
                  fontWeight: 900,
                  boxShadow:
                    mode === "dark"
                      ? "0 10px 20px rgba(8,131,255,0.22)"
                      : "0 10px 20px rgba(17,97,73,0.22)",
                  "&:hover": {
                    backgroundColor: mode === "dark" ? "#0672df" : "#0f523e",
                  },
                }}
                endIcon={<CheckIcon sx={{ fontSize: 17 }} />}
              >
                Yes
              </Button>

              <Button
                color="error"
                size="small"
                onClick={handleClose}
                variant="contained"
                sx={{
                  flex: 1,
                  height: 36,
                  borderRadius: "12px",
                  textTransform: "capitalize",
                  fontSize: 12,
                  fontWeight: 900,
                  boxShadow: "none",
                }}
                endIcon={<CancelIcon sx={{ fontSize: 17 }} />}
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
